import { FlowNodeType } from '@prisma/client';

import { AppIcon, AppIconColourVariant, AppIconGroup, AppIconVariant } from '@/ui-library';

import { TEMPLATE_APP_ICON_COUNT } from '../flow-templates.constants';
import type { TemplateAppIconGroupProps } from '../flow-templates.types';

export const TemplateAppIconGroup: React.FC<TemplateAppIconGroupProps> = (props) => {
  const { templateNodes } = props;

  const totalNodeCount = templateNodes.filter((node) => node.type !== FlowNodeType.PATH).length;
  const hiddenNodeCount = totalNodeCount - 2;
  const placeHolderIconCount = Math.max(TEMPLATE_APP_ICON_COUNT - templateNodes.length, 0);
  const placeholderArray = new Array(placeHolderIconCount).fill(null).map((_, index) => index);

  return (
    <AppIconGroup>
      {templateNodes.map((templateNode, index) => {
        const isFirstNode = index === 0;
        const isLastNode = index + 1 === totalNodeCount;
        const showAppIcon =
          totalNodeCount <= TEMPLATE_APP_ICON_COUNT ||
          (totalNodeCount > TEMPLATE_APP_ICON_COUNT && (isFirstNode || isLastNode));
        const showCount = hiddenNodeCount > 0 && index === 1;

        if (showAppIcon)
          return (
            <AppIcon
              key={templateNode.id}
              variant={AppIconVariant.APP}
              icon={{ src: templateNode.icon, alt: 'App icon' }}
              colourVariant={AppIconColourVariant.LIGHT}
            />
          );
        if (showCount)
          return (
            <AppIcon
              key={templateNode.id}
              variant={AppIconVariant.COUNT}
              count={hiddenNodeCount}
              colourVariant={AppIconColourVariant.LIGHT}
            />
          );
        return null;
      })}
      {placeholderArray.map((pos) => (
        <AppIcon key={pos} variant={AppIconVariant.PLACEHOLDER} colourVariant={AppIconColourVariant.LIGHT} />
      ))}
    </AppIconGroup>
  );
};
